export const DECISION_CATEGORIES = Object.freeze({
  GOVERNANCE_BLOCKED: "governance_blocked",
  GOVERNANCE_REVIEW: "governance_review",
  PUBLICATION_DECISION: "publication_decision",
  DRAFT_ATTENTION: "draft_attention",
  OPPORTUNITY_QUALITY_WARNING: "opportunity_quality_warning",
  OPPORTUNITY_READY: "opportunity_ready",
});

export const DECISION_QUEUE_POLICY = Object.freeze({
  version: 1,
  maxItems: 5,
  priorityOrder: Object.freeze([
    DECISION_CATEGORIES.GOVERNANCE_BLOCKED,
    DECISION_CATEGORIES.GOVERNANCE_REVIEW,
    DECISION_CATEGORIES.PUBLICATION_DECISION,
    DECISION_CATEGORIES.DRAFT_ATTENTION,
    DECISION_CATEGORIES.OPPORTUNITY_QUALITY_WARNING,
    DECISION_CATEGORIES.OPPORTUNITY_READY,
  ]),
  tieBreakers: Object.freeze(["category", "highPriorityCountDescending", "titleAscending"]),
});

const PRIORITY_BY_CATEGORY = new Map(
  DECISION_QUEUE_POLICY.priorityOrder.map((category, index) => [category, index])
);

export function decisionCategoryPriority(category) {
  const priority = PRIORITY_BY_CATEGORY.get(category);
  if (priority === undefined) throw new Error(`Unknown decision queue category: ${category}`);
  return priority;
}

export function highPriorityTieBreaker(count) {
  const numericCount = Number(count);
  return Number.isFinite(numericCount) ? -numericCount : 0;
}

export function compareDecisionQueueItems(left, right) {
  return (
    decisionCategoryPriority(left.category) - decisionCategoryPriority(right.category) ||
    (left.secondaryPriority || 0) - (right.secondaryPriority || 0) ||
    left.title.localeCompare(right.title, "en", { sensitivity: "base" })
  );
}

export function rankDecisionQueue(items) {
  return [...items].sort(compareDecisionQueueItems).slice(0, DECISION_QUEUE_POLICY.maxItems);
}
